/**
 * 高级设置-推荐设置
 * @author ariel
 * @date 2020-12-09
 */
import React from "react";
import {component_tool, framework_tool} from '../../../tool'

const {WizComponent, WizForm, Wizmessage,WizTooltip,WizIcon} = component_tool
const {WizAvatarUpload} = framework_tool

const platforms = {
  'PC': 0,
  'APP': 1,
}

const positions = {
  '首页轮播': 0,
  '广告位': 1,
  '路径推荐位': 2,
  '任务推荐位': 3
}

const correspondence = {
  'PC': ['首页轮播', '广告位', '路径推荐位', '任务推荐位'],
  'APP': ['首页轮播', '', '路径推荐位', '任务推荐位'],
}

export default class WizFeaturedSet extends WizComponent {
  constructor(props) {
    super(props);
    this.state={
      entityType: props.entityType
    }
  }

  _onFeaturedSubmit(values) {
    let {submit} = this.props;

    values['startDate'] = values['startDate'].valueOf()
    values['endDate'] = values['endDate'].valueOf()
    if (values['startDate']  > values['startDate'] ) {
      wizNotice.error('生效时间不能大于失效时间')
      return
    }

    let advertising = values['advertising']
    if (advertising && advertising.length) {
      values['advertisingImg'] = advertising[0]['fileId']
      delete values['advertising']
    }

    let advertisingApp = values['advertisingApp']
    if (advertisingApp && advertisingApp.length) {
      values['advertisingAppImg'] = advertisingApp[0]['fileId']
      delete values['advertisingApp']
    }

    let carousel = values['carousel']
    if (carousel && carousel.length) {
      values['carouselImg'] = carousel[0]['fileId']
      delete values['carousel']
    }

    let busWx = values['busWx']
    if (busWx && busWx.length) {
      values['busWxImg'] = busWx[0]['fileId']
      delete values['busWx']
    }

    let path = values['path']
    if (path && path.length) {
      values['pathImg'] = path[0]['fileId']
      delete values['path']
    }
     let task = values['task']
      if (task && task.length) {
        values['taskImg'] = task[0]['fileId']
        delete values['task']
      }
    submit(values)
  }

  _getRecord = (record) => {
    let selectedPlatforms = []
    let optionalPosition = []
    let selectedPosition = []
    if (record && record.entityId) {
      selectedPlatforms = record.platforms
      selectedPosition = record.positions
      optionalPosition = this._optionalPosition(record.platforms)
    }
    this.setState({
      record,
      selectedPlatforms,
      optionalPosition,
      selectedPosition
    })
  }

  _optionalPosition = (value) => {
    let optionalPosition = []
    let platformObj = {}
    for (let [key, value] of Object.entries(platforms)) {
      platformObj[value] = key
    }
    Array.isArray(value) && value.map(code => {
      let platform = platformObj[code]
      let positionCodeArr = correspondence[platform].map(position => positions[position])
      return positionCodeArr
    }).forEach(arr => arr.forEach(item => !optionalPosition.includes(item) && optionalPosition.push(item)))
    return optionalPosition
  }

  /**
   * 发布平台变化时，计算可选推荐位并清除已选中的不可选推荐位
   * @param {*} form
   * @param {*} value
   */
  _platformsOnChange = (form, value) => {
    let {record} = this.props
    if(record.entityId ) {
      this._getRecord(record)
    }
    let optionalPosition = []
    let positionsValue = form.getFieldValue('positions')
    if (value && value.length) {
      optionalPosition = this._optionalPosition(value)
      positionsValue = positionsValue && positionsValue.length && positionsValue.filter(positionValue => optionalPosition.includes(positionValue))
    } else {
      positionsValue = []
    }
    form.setFieldsValue({ positions: positionsValue })
    this.setState({ selectedPlatforms: value, optionalPosition })
  }

  _positionsOnChange = (form, value) => {
    let {record} = this.props
    if(record.entityId ) {
      this._getRecord(record)
    }
    this.setState({ selectedPosition: value })
  }

  /**
   * 动态选项
   * @param {*} data
   * @param {*} flag
   */
  _dict = (data,record, flag) => {
    let {entityType} = this.state
    let dict = []
    let taskTypeList = [0,1,26,15,45,59]
    for (let [key, value] of Object.entries(data)) {
      let item = { code: value, codeName: key }
      if (record) {
        item.disabled = false
      } else if (flag) {
        item.disabled = !this.state.optionalPosition.includes(value)
      }
      dict.push(item)
      if (flag && !taskTypeList.includes(entityType) && value === 3 ) {
        dict.splice(dict.indexOf(value),1)
      }
    }
    return dict
  }

  render() {
    let {record} = this.props
    let {selectedPlatforms, selectedPosition, entityType } = this.state
    let taskTypeList = [0,1,26,15,45,59]
    let platformDict = this._dict(platforms)
    let positionDict = this._dict(positions, record,true)
    let columns = []
    columns = columns.concat([
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: record && record.id
        }
      },
      {
        title: '生效时间',
        name: 'startDate',
        formItem: {
          initialValue: record && record.startDate,
          type: 'date',
          rules: [
            {
              required: true,
              message: '生效时间必填'
            }
          ],
          format: 'YYYY-MM-DD HH:mm',
          showTime: {
            format: 'HH:mm'
          }
        }
      },
      {
        title: '结束时间',
        name: 'endDate',
        formItem: {
          initialValue: record && record.endDate,
          type: 'date',
          rules: [
            {
              required: true,
              message: '结束时间必填'
            }
          ],
          format: 'YYYY-MM-DD HH:mm',
          showTime: {
            format: 'HH:mm'
          }
        }
      },
      {
        name: 'platforms',
        title: '发布平台',
        dict: platformDict,
        formItem: {
          type: 'checkbox',
          rules: [{ required: true, message: '请选择发布平台' }],
          onChange: this._platformsOnChange,
          initialValue: record && record.platforms
        }
      },
      {
        title: '推荐位',
        name: 'positions',
        dict: positionDict,
        formItem: {
          type: 'checkbox',
          rules: [{ required: true, message: '请选择推荐位' }],
          onChange: this._positionsOnChange,
          initialValue: record && record.positions
        }
      },
      {
        title: <span>
        PC、APP轮播图&nbsp;
        <WizTooltip title="请上传大小不超过1MB,图片尺寸建议645*334">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        name: 'carouselImg',
        formItem: {
          type: 'custom',
          render: (info, form) => {
            const {getFieldDecorator} = form
            let initialValue = undefined
            if (record && record.carouselImg) {
              initialValue = [{ fileId: record.carouselImg }]
            }
            let formFieldOptions = { initialValue }
            if (record && record.positions && record.positions.length && record.positions.includes(positions['首页轮播'])
              && record.platforms && record.platforms.length
              && (record.platforms.includes(platforms['PC']) || record.platforms.includes(platforms['APP'])) ){
              formFieldOptions.rules = [{ required: true, message: '请选择上传PC、APP轮播图' }]
            } else if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
              && selectedPlatforms && selectedPlatforms.length && (selectedPlatforms.includes(platforms['PC']) || selectedPlatforms.includes(platforms['APP']))) {
              formFieldOptions.rules = [{ required: true, message: '请选择上传PC、APP轮播图' }]
            }
            return (
              <>
                {getFieldDecorator('carousel', formFieldOptions)(
                  <WizAvatarUpload
                    key={record && record.carouselImg || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={645 / 334}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('PC、APP轮播图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      // {
      //   title: '企业微信轮播图',
      //   name: 'busWxImg',
      //   formItem: {
      //     type: 'custom',
      //     render: (info, form) => {
      //       const {getFieldDecorator} = form
      //       let initialValue = undefined
      //       if (record && record.busWxImg) {
      //         initialValue = [{ fileId: record.busWxImg }]
      //       }
      //       let formFieldOptions = { initialValue }
      //       if (record && record.positions && record.positions.length && record.positions.includes(positions['首页轮播'])
      //         && record.platforms && record.platforms.length && record.platforms.includes(platforms['凯迪拉克IQ'])){
      //         formFieldOptions.rules = [{ required: true, message: '请选择上传企业微信轮播图' }]
      //       } else if ((selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
      //         && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['凯迪拉克IQ']))
      //         || (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
      //         && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['雪佛兰企微']))
      //         || (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
      //         && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['别克企微']))
      //         || (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
      //         && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['凯迪拉克企微']))) {
      //         formFieldOptions.rules = [{ required: true, message: '请选择上传企业微信轮播图' }]
      //       }
      //       return (
      //         <>
      //           {getFieldDecorator('busWx', formFieldOptions)(
      //             <WizAvatarUpload
      //               key={record && record.busWxImg || ''}
      //               accept={'.jpg, .jpeg, .png'}
      //               listType={'picture-card'}
      //               aspectRatio={560 / 500}
      //               beforeUpload={(file) => {
      //                 const isLt1M = file.size / 1024 / 1024 < 1
      //                 if (!isLt1M) {
      //                   Wizmessage.error('企业微信轮播图片不得超过1MB!')
      //                 }
      //                 return isLt1M
      //               }}
      //             />
      //           )}
      //         </>
      //       )
      //     }
      //   }
      // },
      {
        title: <span>
        PC广告图&nbsp;
        <WizTooltip title="请上传大小不超过1MB,图片尺寸建议1160*170">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        formItem: {
          type: 'custom',
          render: (info, form) => {
            const {getFieldDecorator} = form
            let initialValue = undefined
            if (record && record.advertisingImg) {
              initialValue = [{ fileId: record.advertisingImg }]
            }
            let formFieldOptions = { initialValue }
            if (record && record.platforms && record.platforms.length && record.platforms.includes(platforms['PC'])
               && record.positions && record.positions.length && record.positions.includes(positions['广告位'])
            ){
              formFieldOptions.rules = [{ required: true, message: '请选择上传PC广告图' }]
            } else if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['广告位'])
              && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['PC'])) {
              formFieldOptions.rules = [{ required: true, message: '请选择上传PC广告图' }]
            }
            return (
              <>
                {getFieldDecorator('advertising', formFieldOptions)(
                  <WizAvatarUpload
                    key={record && record.advertisingImg || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={1160 / 170}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('pc广告图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      // {
      //   title: <span>
      //   APP广告图&nbsp;
      //   <WizTooltip title="请上传大小不超过1MB,图片尺寸建议464*136">
      //       <WizIcon type="question-circle-o" />
      //   </WizTooltip>
      // </span>,
      //   formItem: {
      //     type: 'custom',
      //     render: (info, form) => {
      //       const {getFieldDecorator} = form
      //       let initialValue = undefined
      //       if (record && record.advertisingAppImg) {
      //         initialValue = [{ fileId: record.advertisingAppImg }]
      //       }
      //       let formFieldOptions = { initialValue }
      //       if (record && record.platforms && record.platforms.length && record.platforms.includes(platforms['APP'])
      //         && record.positions && record.positions.length && record.positions.includes(positions['广告位'])
      //       ){
      //         formFieldOptions.rules = [{ required: true, message: '请选择上传APP广告图' }]
      //       } else if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['广告位'])
      //         && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['APP'])) {
      //         formFieldOptions.rules = [{ required: true, message: '请选择上传APP广告图' }]
      //       }
      //       return (
      //         <>
      //           {getFieldDecorator('advertisingApp',formFieldOptions)(
      //             <WizAvatarUpload
      //               key={record && record.advertisingAppImg || ''}
      //               accept={'.jpg, .jpeg, .png'}
      //               listType={'picture-card'}
      //               aspectRatio={464 / 136}
      //               beforeUpload={(file) => {
      //                 const isLt1M = file.size / 1024 / 1024 < 1
      //                 if (!isLt1M) {
      //                   Wizmessage.error('App广告图片不得超过1MB!')
      //                 }
      //                 return isLt1M
      //               }}
      //             />
      //           )}
      //         </>
      //       )
      //     }
      //   }
      // },
      {
        title: <span>
        路径推荐图&nbsp;
        <WizTooltip title="请上传大小不超过1MB,图片尺寸建议400*207">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        formItem: {
          type: 'custom',
          render: (info, form) => {
            const {getFieldDecorator} = form
            let initialValue = undefined
            if (record && record.pathImg) {
              initialValue = [{ fileId: record.pathImg }]
            }
            let formFieldOptions = { initialValue }
            if (record && record.platforms && record.platforms.length && record.platforms.includes(positions['路径推荐位'])){
              formFieldOptions.rules = [{ required: true, message: '请选择上传路径推荐图' }]
            } else if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['路径推荐位'])) {
              formFieldOptions.rules = [{ required: true, message: '请选择上传路径推荐图' }]
            }
            return (
              <>
                {getFieldDecorator('path', formFieldOptions)(
                  <WizAvatarUpload
                    key={record && record.pathImg || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('路径推荐图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      taskTypeList.includes(entityType) ?
      {
        title: <span>
        任务推荐图&nbsp;
        <WizTooltip title="请上传大小不超过1MB,图片尺寸建议400*207">
            <WizIcon type="question-circle-o" />
        </WizTooltip>
      </span>,
        formItem: {
          type: 'custom',
          render: (info, form) => {
            const {getFieldDecorator} = form
            let initialValue = undefined
            if (record && record.taskImg) {
              initialValue = [{ fileId: record.taskImg }]
            }
            let formFieldOptions = { initialValue }
            if (record && record.platforms && record.platforms.length && record.platforms.includes(positions['任务推荐位'])){
              formFieldOptions.rules = [{ required: true, message: '请选择上传任务推荐图' }]
            } else if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['任务推荐位'])) {
              formFieldOptions.rules = [{ required: true, message: '请选择上传任务推荐图' }]
            }
            return (
              <>
                {getFieldDecorator('task', formFieldOptions)(
                  <WizAvatarUpload
                    key={record && record.taskImg || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('任务推荐图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )}
              </>
            )
          }
        }
      }: {},
      {
        title: "状态",
        name: "state",
        dict: [
          { code: 0, codeName: '草稿' },
          { code: 1, codeName: '已打开' },
          { code: 2, codeName: '已关闭' }
        ],
        formItem: {
          type: 'radio',
          initialValue: record && record.state ? record.state : 0
        }
      },
    ])

    let onFeaturedSubmit = this._onFeaturedSubmit.bind(this)

    let formProps = {
      ref: 'form',
      columns: columns,
      onSubmit: onFeaturedSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <>
        <WizForm {...formProps} />
      </>
    )
  }

}

WizFeaturedSet.defaultProps = {}

WizFeaturedSet.propTypes = {}
